export enum MediaQuery {
  mobile = '(max-width: 767px)',
  tablet = '(max-width: 1199px)',
  desktop = '(min-width: 1200px)',
}
